import { render, staticRenderFns } from "./StrategicAllocations.vue?vue&type=template&id=ec790e64&scoped=true"
import script from "./StrategicAllocations.vue?vue&type=script&lang=ts"
export * from "./StrategicAllocations.vue?vue&type=script&lang=ts"
import style0 from "./StrategicAllocations.vue?vue&type=style&index=0&id=ec790e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec790e64",
  null
  
)

export default component.exports